/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { mediaImageIndex } from '../../axios/mediaImageIndex'
import type { MediaImageIndexError, MediaImageIndexResponse } from '../../types/MediaImageIndex'

export const mediaImageIndexQueryKey = () => [{ url: '/media/images' }] as const

export type MediaImageIndexQueryKey = ReturnType<typeof mediaImageIndexQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::index */
export function mediaImageIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		MediaImageIndexResponse,
		AxiosError<MediaImageIndexError>,
		MediaImageIndexResponse,
		MediaImageIndexQueryKey
	>({
		queryKey: mediaImageIndexQueryKey(),
		queryFn: ({ signal }) => mediaImageIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::index */
export function useMediaImageIndex<TSelectData = MediaImageIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					MediaImageIndexResponse,
					AxiosError<MediaImageIndexError>,
					TSelectData,
					MediaImageIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<MediaImageIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...mediaImageIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::index */
export function useMediaImageIndexSuspense<TSelectData = MediaImageIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					MediaImageIndexResponse,
					AxiosError<MediaImageIndexError>,
					TSelectData,
					MediaImageIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<MediaImageIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...mediaImageIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
